import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import DeleteGatheringAddonDocument from "src/api/graphql/__generated__/documents/DeleteGatheringAddonDocument";
import log from "src/helpers/log";
import { useInsideModal } from "src/modals";
import GatheringModal from "src/modals/configs/GatheringModal";

const useDeleteGatheringAddon = () => {
	const {
		closeSelf,
		props: { gatheringId, addonId },
	} = useInsideModal<GatheringModal["GatheringAddonEditModal"]>();
	const apolloClient = useApolloClient();

	const handleDelete = useCallback(async () => {
		if (!addonId) {
			log.error({ addonId, gatheringId }, "Failed to delete because addonId is missing");
			return;
		}
		await apolloClient.mutate({
			mutation: DeleteGatheringAddonDocument,
			variables: { input: { addonId, gatheringId } },
		});
		closeSelf();
	}, [closeSelf, apolloClient, gatheringId, addonId]);

	return handleDelete;
};
export default useDeleteGatheringAddon;
